const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    height: 19,
    id: "screenshot-738c4961-3268-8021-8007-7a168749d80b",
    viewBox: "-1408 2242 10 19",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d80b",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d812",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d812"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: -1408,
    y: 2242,
    transform: "matrix(-1.000000, 0.000000, 0.000000, 1.000000, -2806.000000, 0.000000)",
    width: 10,
    height: 19,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d813"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d814",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d815"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d815"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1398.7783203125,2260.6904296875C-1399.0166015625,2260.513671875,-1400.9486083984375,2258.8515625,-1401.7637939453125,2258.0380859375C-1401.8096923828125,2258.0380859375,-1401.8460693359375,2258.029296875,-1401.8826904296875,2258.01171875C-1401.8826904296875,2258.01171875,-1401.8919677734375,2258.01171875,-1401.901123046875,2258.01171875C-1401.901123046875,2258.01171875,-1401.901123046875,2258.01171875,-1401.901123046875,2258.01171875C-1401.9833984375,2257.9853515625,-1402.047607421875,2257.92333984375,-1402.0933837890625,2257.81689453125C-1403.7052001953125,2254.0771484375,-1405.3260498046875,2250.3369140625,-1406.9378662109375,2246.59716796875C-1407.166748046875,2246.06689453125,-1407.395751953125,2245.5361328125,-1407.62451171875,2245.005859375C-1407.642822265625,2244.970703125,-1407.652099609375,2244.93505859375,-1407.6612548828125,2244.89990234375C-1407.9725341796875,2243.900390625,-1407.5604248046875,2242.7958984375,-1406.5074462890625,2242.37109375C-1405.46337890625,2241.947265625,-1404.2181396484375,2242.44189453125,-1403.7784423828125,2243.458984375C-1402.166748046875,2247.19873046875,-1400.5457763671875,2250.93896484375,-1398.9339599609375,2254.6787109375C-1398.7052001953125,2255.208984375,-1398.4761962890625,2255.7392578125,-1398.247314453125,2256.26953125C-1398.1923828125,2256.40283203125,-1398.22900390625,2256.552734375,-1398.320556640625,2256.6591796875C-1398.320556640625,2256.95947265625,-1398.311279296875,2257.259765625,-1398.30224609375,2257.560546875C-1398.30224609375,2257.7021484375,-1398.30224609375,2257.84375,-1398.30224609375,2257.994140625C-1398.283935546875,2258.8251953125,-1398.2747802734375,2259.6474609375,-1398.2564697265625,2260.478515625C-1398.3387451171875,2260.7880859375,-1398.54931640625,2260.8671875,-1398.7691650390625,2260.69970703125Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1d8ad3ba-c440-8062-8007-83ea0e656aa3-738c4961-3268-8021-8007-7a168749d815",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1398.7783203125,2260.6904296875C-1399.0166015625,2260.513671875,-1400.9486083984375,2258.8515625,-1401.7637939453125,2258.0380859375C-1401.8096923828125,2258.0380859375,-1401.8460693359375,2258.029296875,-1401.8826904296875,2258.01171875C-1401.8826904296875,2258.01171875,-1401.8919677734375,2258.01171875,-1401.901123046875,2258.01171875C-1401.901123046875,2258.01171875,-1401.901123046875,2258.01171875,-1401.901123046875,2258.01171875C-1401.9833984375,2257.9853515625,-1402.047607421875,2257.92333984375,-1402.0933837890625,2257.81689453125C-1403.7052001953125,2254.0771484375,-1405.3260498046875,2250.3369140625,-1406.9378662109375,2246.59716796875C-1407.166748046875,2246.06689453125,-1407.395751953125,2245.5361328125,-1407.62451171875,2245.005859375C-1407.642822265625,2244.970703125,-1407.652099609375,2244.93505859375,-1407.6612548828125,2244.89990234375C-1407.9725341796875,2243.900390625,-1407.5604248046875,2242.7958984375,-1406.5074462890625,2242.37109375C-1405.46337890625,2241.947265625,-1404.2181396484375,2242.44189453125,-1403.7784423828125,2243.458984375C-1402.166748046875,2247.19873046875,-1400.5457763671875,2250.93896484375,-1398.9339599609375,2254.6787109375C-1398.7052001953125,2255.208984375,-1398.4761962890625,2255.7392578125,-1398.247314453125,2256.26953125C-1398.1923828125,2256.40283203125,-1398.22900390625,2256.552734375,-1398.320556640625,2256.6591796875C-1398.320556640625,2256.95947265625,-1398.311279296875,2257.259765625,-1398.30224609375,2257.560546875C-1398.30224609375,2257.7021484375,-1398.30224609375,2257.84375,-1398.30224609375,2257.994140625C-1398.283935546875,2258.8251953125,-1398.2747802734375,2259.6474609375,-1398.2564697265625,2260.478515625C-1398.3387451171875,2260.7880859375,-1398.54931640625,2260.8671875,-1398.7691650390625,2260.69970703125Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d816"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d816"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1403.7052001953125,2243.64453125L-1407.3680419921875,2245.1650390625",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1d8ad3ba-c440-8062-8007-83ea0e656aa4-738c4961-3268-8021-8007-7a168749d816",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1403.7052001953125,2243.64453125L-1407.3680419921875,2245.1650390625",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d817"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1398.2564697265625,2256.26953125C-1398.4578857421875,2256.3232421875,-1402.1025390625,2257.81689453125,-1402.1025390625,2257.81689453125",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1d8ad3ba-c440-8062-8007-83ea0e656aa5-738c4961-3268-8021-8007-7a168749d817",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1398.2564697265625,2256.26953125C-1398.4578857421875,2256.3232421875,-1402.1025390625,2257.81689453125,-1402.1025390625,2257.81689453125",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ad9ecbcf7069dc45c0aceac14db91772.svg";
export { ForwardRef as ReactComponent };